<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

        <!-- 左边 -->
        <div style="margin:5px;float:right">
                <el-button size="mini" type="success" @click="openModel">添加预约参观</el-button>
            </div>

        <el-table :data="tableData" border style="width: 100%" v-loading="loadings" :height="height"
            ref="configurationTable">
            <el-table-column prop="user_name" label="姓名" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="user_mobile" label="电话" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="project_id_text" label="项目" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="visit_date" label="预约时间" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                    {{scope.row.visit_date.substring(0,13)}}:00
                </template>
            </el-table-column>
             <el-table-column prop="source_id_text" label="获知途径" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="status_text" label="状态" show-overflow-tooltip align="center">
            </el-table-column>
            <!-- <el-table-column label="操作" width="250" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" size="mini">编辑</el-button>
                </template>
            </el-table-column> -->
        </el-table>
        <div style="float:right">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="curPage"
                :page-sizes="[10, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="count">
            </el-pagination>
        </div>

        <el-dialog :title="names" :visible.sync="dialogVisible" top='20px'>
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
                    <el-form-item label="项目">
                        <el-select v-model="ruleForm.project" placeholder="请选择" size="small" style="width:30%">
                            <el-option v-for="item in project_options" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="姓名">
                        <el-input v-model="ruleForm.user_name" placeholder="请输入内容" style="width:30%"></el-input>
                    </el-form-item>
                    <el-form-item label="电话">
                        <el-input v-model="ruleForm.user_mobile" placeholder="请输入内容" style="width:30%"></el-input>
                    </el-form-item>
                    <el-form-item label="预约时间">
                        <el-date-picker v-model="ruleForm.visit_date" type="datetime" placeholder="选择日期时间" style="width:30%"
                            value-format="yyyy-MM-dd HH:mm:ss">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="获取路径1">
                        <el-select v-model="ruleForm.source" placeholder="请选择" size="small" style="width:30%">
                            <el-option v-for="item in source_options" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="获取路径2">
                        <el-select v-model="ruleForm.source2" placeholder="请选择" size="small" style="width:30%">
                            <el-option v-for="item in source_options2" :key="item.id" :label="item.content_name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size='small'>取 消</el-button>
                <el-button @click="subForm" size='small' type="primary">提交</el-button>
            </span>
        </el-dialog>

        
    </div>
</template>

<script>
    import buttonSearch from "@/components/common/button-search.vue"
    import common from '@/common/mixins/common.js';
    export default {
        inject: ['app', 'layout'],
        mixins: [common],
        components: {
            buttonSearch,
        
        },
        data() {
            return {
                namenc: false,
                names: '',
                pageSize: 10,
                curPage: 1,
                count: 0,
                tableData: [],
                loadings: false,
                height: null,
                dialogVisible: false,
                project_options:[],
                source_options:[],
                source_option2:[],
                ruleForm: {
                   project:'',
                   user_name:'',
                   user_mobile:'',
                   visit_date:'',
                   source:'',
                   source2:'',
                },
                rules: {},
               
                eid: '',
                // 操作项目的id
                operateProjectId: null,
            }
        },
        computed: {

        },
        mounted() {
            let that = this
            that.getHeight()
            that.search()
            that.gettj()
            that.getxm()
        },
        methods: {
            getHeight() {
                let that = this // window.innerHeight   获取动态表格高度
                that.height = window.innerHeight - 350 + 'px'
                window.onresize = () => {
                    that.height = window.innerHeight - 350 + 'px'
                }
            },
            search() {
                let that = this
                axios
                    .post("/admin/lgOrderinfo/index", {
                        limit: that.pageSize,
                        page: that.curPage,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.tableData = response.data.data.data
                        that.count = response.data.data.total
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pageSize = val
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.curPage = val
                that.search()
            },
            getxm() {
                let that = this
                axios
                    .post("/admin/lgProject/index", {
                       limit:10,
                       page:1,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.project_options = response.data.data.data
                    })
                    .catch(error => {})
            },
            gettj() {
                let that = this
                axios
                    .post("/admin/lgSource/index", {
                        pid:0
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.source_options = response.data.data
                    })
                    .catch(error => {})
            },
           

            openModel() {
                let that = this
                that.dialogVisible = true
                that.names = '新增'
                that.namenc = true
                that.ruleForm.project = ''
                that.ruleForm.user_name = ''
                that.ruleForm.user_mobile = ''
                that.ruleForm.visit_date = ''
                that.ruleForm.source = ''
            },
            subForm() {
                let that = this
                if(that.namenc == true){
                     axios
                    .post("/admin/lgOrderinfo/Madd", {
                        // id: that.namenc == true ? 0 : that.eid,
                        project_id: that.ruleForm.project,
                        user_name: that.ruleForm.user_name,
                        user_mobile: that.ruleForm.user_mobile,
                        visit_date: that.ruleForm.visit_date,
                        source_id:that.ruleForm.source,
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == 200) {
                            this.$message({
                                showClose: true,
                                type: 'success',
                                message: response.data.msg

                            });
                            that.dialogVisible = false
                            that.search()
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.data.msg,
                                type: 'error'
                            });
                        }
                    })
                    .catch(error => {})
                }
                if(that.namenc != true){
                     axios
                    .post("/admin/lgOrderinfo/Medit", {
                        id: that.eid,
                        project_id: that.ruleForm.project,
                        user_name: that.ruleForm.user_name,
                        user_mobile: that.ruleForm.user_mobile,
                        visit_date: that.ruleForm.visit_date,
                        source_id:that.ruleForm.source,
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == 200) {
                            this.$message({
                                showClose: true,
                                type: 'success',
                                message: response.data.msg

                            });
                            that.dialogVisible = false
                            that.search()
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.data.msg,
                                type: 'error'
                            });
                        }
                    })
                    .catch(error => {})
                }
               
            },
            //编辑
            async handleClick(row) {
                let that = this
                that.dialogVisible = true
                that.names = '编辑'
                that.namenc = false
                that.ruleForm.project = row.project_id
                that.ruleForm.user_name = row.user_name
                that.ruleForm.user_mobile = row.user_mobile
                that.ruleForm.visit_date = row.visit_date
                that.ruleForm.source = row.source_id
                that.eid = row.id
            },

        },
    }
</script>

<style>
</style>